/*
 * Join Ctrl
 * Shared by step2 and step3
 * during enrollment
 */

module.controller('step-2-3-joinCtrl', ['$scope', '$state', '$http', 'Session', 'STATES', 'SECURITY_QUESTIONS', 'SECURITY_QUESTIONS_MOBILE', 'EV_STEP2', 'EV_STEP3', 'ENROLLMENT_ERROR', 'Transform', 'ValidateService', 'baseURI', '$rootScope', 'authService', '$window', '$q', 'LimitsService', 'cacheService', '$stateParams', 'SigmaDeviceRiskService', 'countryCodes', function ($scope, $state, $http, Session, STATES, SECURITY_QUESTIONS, SECURITY_QUESTIONS_MOBILE, EV_STEP2, EV_STEP3, ENROLLMENT_ERROR, Transform, ValidateService, baseURI, $rootScope, authService, $window, $q, LimitsService, cacheService, $stateParams, SigmaDeviceRiskService, countryCodes) {
  $scope.loading = false;
  $scope.usernameBlurred = false;
  $scope.passwordBlurred = false;
  $scope.validUsername = false;
  $scope.states = STATES;
  $scope.formData.NRA = 'Y';
  $scope.backStep2 = 'root.join.step1';
  $scope.latestAgeYear = new Date().getFullYear() - 18;

  var countries = [];
  for (var code in countryCodes.codeToCountry) {
    if (countryCodes.codeToCountry.hasOwnProperty(code)) {
      countries.push({
        code: code,
        name: countryCodes.codeToCountry[code]
      });
    }
  }
  $scope.countries = countries;

  var sessionId;
  var onSuccess = function(Id){
    sessionId = Id;
  };
  var onError = function() {
    console.catch("Socure Device Risk Response Error");
  };
  SigmaDeviceRiskService.getSessionToken(onSuccess, onError);

  // set questions according to screen size
  $scope.questions = ($window.innerWidth < 768) ?  SECURITY_QUESTIONS_MOBILE : SECURITY_QUESTIONS;
  var mobileApp = ($state.params.ma === '1') ? true : false;

  // we lost the form data (ios mail issue #108467498)
  if(!$scope.formData.Email && $rootScope.step1FormData){
    $scope.$parent.formData = $rootScope.step1FormData;
    $scope.$parent.validation.verifiedEmail = $scope.$parent.validation.validEmail = $scope.$parent.validation.uniqueEmail = true;
  } else {
    $rootScope.step1FormData = null;
  }

  if($scope.joinType != 'register'){
    $scope.backStep4 = 'root.join.step4';
  } else {
    $scope.backStep4 = 'root.join.step1';
  }

  $scope.clearSsn = function(){
    if($scope.formData.NoSsn){
      $scope.formData.Ssn1 = '';
      $scope.formData.Ssn2 = '';
      $scope.formData.Ssn3 = '';
    }
  };

  $scope.checkUsername = function(value){
    value = value || '';
    var url = baseURI + 'cardholder/checkusername/';
    if (value.length < 6){
      $scope.$parent.validation.validUsername = false;
      $scope.$parent.validation.usernameBlurred = true;
    } else {
      $http({
        method: 'GET',
        url: url + value,
      }).then(function (resp){
        var data = resp.data;

        $scope.$parent.validation.uniqueUsername = data.Success;
      }).catch(function (error){
        $scope.$parent.validation.uniqueUsername = false;
      }).then(function(){
        $scope.$parent.validation.validUsername = true;
        $scope.$parent.validation.usernameBlurred = true;
      });
    }
  };

  var goToSuccessPage = function(message) {
    $state.go('root.join.success', {
      successMessage: message,
      credentials: {
        username: $scope.formData.Email,
        password: $scope.formData.Password,
        brand: $scope.brand.name,
        _key: $scope.brand.api_key
      },
    });
  };

  $scope.validateAndNext = function(formData){
    $window.scrollTo(0,0);
    var valid = true;

    for(var input in EV_STEP2){
      // Ignore Ssn fields if NoSsn is checked
      if (formData.NoSsn && (input === 'Ssn1' || input === 'Ssn2' || input === 'Ssn3')) {
        continue;
      }

      if(!formData[input]){
        $scope.alertError.show = true;
        $scope.alertError.message = EV_STEP2[input].message;
        valid = false;
        break;
      }
    }


    if(valid && !formData.FirstName.match(/^[a-zA-Z- ']+$/)){
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please provide only letters for the first name.';
      valid = false;
    }
    if(valid && !formData.LastName.match(/^[a-zA-Z- ']+$/)){
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please provide only letters for the last name.';
      valid = false;
    }
    if(valid){
      $state.go('root.join.step3', {joinType: $scope.joinType});
    }
  };

  $scope.validateAndSubmit = function(formData){
    var valid = true;
    $window.scrollTo(0,0);
    for(var input in EV_STEP2){
      if(!formData[input]){
        $scope.alertError.show = true;
        $scope.alertError.message = EV_STEP2[input].message;
        valid = false;
        break;
      }
    }
    if(valid && !formData.FirstName.match(/^[a-zA-Z- ']+$/)){
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please provide only letters for the first name.';
      valid = false;
    }
    if(valid && !formData.LastName.match(/^[a-zA-Z- ']+$/)){
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please provide only letters for the last name.';
      valid = false;
    }
    if(valid){
      $state.go('root.join.step3', {joinType: $scope.joinType});
    }
  };


  $scope.validateStep3 = function(formData){
    var valid = true;

    // Loop input's validating required
    for(var input in EV_STEP3){
      if(!formData[input]){
        $scope.alertError.show = true;
        $scope.alertError.message = EV_STEP3[input].message;
        valid = false;
        break;
      }
    }

    // Check if pw and pw1 match
    if(valid && formData.Password != formData.Password1){
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please confirm both passwords are correct';
      valid = false;
    }

    // Check if pw is valid
    if(valid && ValidateService.checkPwd(formData.Password) != 'valid'){
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please make sure your password has' + ValidateService.checkPwd(formData.Password);
      valid = false;
    }
    // Check username length
    if(valid && formData.Username.length < 6){
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please provide a username at least 6 characters long.';
      valid = false;
    }

    // Check if unique username
    if(valid && (!$scope.$parent.validation.validUsername || !$scope.$parent.validation.uniqueUsername)){
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please provide a unique username.';
      valid = false;
    }

    // At this point form is ready for submission
    if(valid && !$scope.loading){
      $scope.loading = true;

      $state.go('root.join.step4', {joinType: $scope.joinType});
    }
  };

  $scope.finalizeStep4 = function(form){
    $scope.submitted = true;
    if(form.$valid) {
      $scope.loading = true;
      if ($scope.joinType != 'register') {
        createCard();
      } else {
        registerCard();
      }
    }
  };

  var goToWelcome = function(data){
    sendGAConversion();
    authService.handleAutoAuth(data);
  };

  var createCard = function(){
    var formData = $scope.formData;

    if(formData.Country == 'US') {
      formData.NRA = 'N';
    }
    // Normalize Post Data
    formData.Phone = formData.Phone1 + formData.Phone2 + formData.Phone3;
    formData.Ssn = formData.NoSsn ? '1' : formData.Ssn1 + formData.Ssn2 + formData.Ssn3;
    formData.Dob = formData.Dob1 + '/' + formData.Dob2 + '/' + formData.Dob3;
    formData._key = $scope.brand.api_key;
    formData.Referrer = $scope.parent.referrer;
    formData.DeviceSessionID = sessionId;
    formData.Username = formData.Email;

    var url = baseURI + 'card/create';
    $http({
      method: 'POST',
      url: url,
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(formData)
    }).then(function (resp){
      var data = resp.data;

      if(data.Success){
        // did this CH select text alerts?
        if($scope.formData.textAlerts){
          data.textAlerts = {
            phoneNumber: formData.Phone,
            subcard: null
          };
        } else {
          data.textAlerts = null;
        }
        //route to welcome screen
        if(mobileApp){
          $state.go('root.join.mobilewelcome');
        }
        else{
          goToWelcome(data);
        }

      } else {
        Session.setUsername($scope.formData.Username);

        var message = "";

        if(data.ErrorCode == 100){
          switch(data.VendorErrorCode){
            case '1075':
              //need SSV
              message = "In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload an image of your Social Security Card or W-2 Form.";
              goToSuccessPage(message);
              break;
            case '1077':
              //bad Proof of Address
              message = "The address you entered could not be verified. In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload your proof of address.";
              goToSuccessPage(message);
              break;
            case '1050':
            case '1076':
              //need drivers license
              message = "We were unable to confirm some of the information you provided. In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload an image of your driver's license or government-issued ID card.";
              goToSuccessPage(message);
              break;
            case '965':
              $scope.alertError.message = 'Oops, looks like you have already signed up with an account.';
              $scope.alertError.resetPassword = true;
              $scope.alertError.show = true;
              break;
            case '942':
            case '1052':
              $scope.alertError.message = 'Sorry, but we cannot ship cards to a P.O. Box. Please try again using a street address.';
              $scope.alertError.show = true;
              $scope.$parent.validateAndSubmitBtn = true;
              $state.go('root.join.step2', {joinType: $scope.joinType});
              break;
            default:
              $scope.alertError.message = ENROLLMENT_ERROR[1] + data.VendorErrorCode;
              $scope.alertError.show = true;
              break;
          }
        } else if(data.ErrorCode == 150){
          //fraud filter error. The user should only have the option to go to the dashboard.
          message = "In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload an image of your driver's license or government-issued ID card.";
          $scope.loading = false;
          goToSuccessPage(message);
        }
        else{
          $scope.alertError.message = ENROLLMENT_ERROR[2];
          $scope.alertError.show = true;
        }
        $scope.loading = false;
      }
    }).catch(function (err){
      var message;

      if(err.data.ErrorCode == 184) {
        //if the promo code is invalid
        $scope.alertError.message = 'Oops, the invitation code provided does not appear to be correct. In order to enroll, you must provide a valid invitation code.';
        $scope.alertError.show = true;
        $scope.loading = false;
      }
      else if(err.data.ErrorCode === 150) {
        //no ssn was selected so the user needs to submit their passport
        message = "In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload an image of your Passport or ID card. Please note: Since you did not provide a Social Security Number, we cannot accept any ID documentation issued by the U.S.";
        $scope.loading = false;
        goToSuccessPage(message);
      }
      else {
        message = err.Data.errors[1].Description;
        goToSuccessPage(message);
        $scope.loading = false;
      }
    }).then(function(){
      $scope.loading = false;
    });
  };

  var registerCard = function(){

    var registerCardUrl = baseURI + 'sub-card/register';

    // Register Card Data
    var registerRequest = {
      _key: $scope.brand.api_key,
      CardNumber: $scope.formData.CardNumber,
      Username: $scope.formData.Email,
      Email: $scope.formData.Email,
      Password: $scope.formData.Password,
    };

    $http({
      method: 'PUT',
      url: registerCardUrl,
      data: Transform.encode(registerRequest),
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
    }).then(function(resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        $state.go('root.join.welcome', {joinType: $scope.joinType});
      } else {
        if(data.ErrorCode === 150) {
          $state.go('member.home.profile/verification.step1', {username: $scope.formData.Username});
        } else {
          $scope.alertError.message = ENROLLMENT_ERROR[1] + data.ErrorCode;
          $scope.alertError.show = true;
        }
      }
    }).catch(function (error){
      $scope.loading = false;
      $scope.alertError.message = ENROLLMENT_ERROR[1] + 100;
      $scope.alertError.show = true;
    });
  };


  // send final ad conversion
  var sendGAConversion = function(){
    gtag('event', 'signup_order_conversion', {
      'send_to': 'G-N24N1YZ4VJ',
      'value': 1.00,
      'currency': 'USD'
    });
    gtag('event', 'signup_order_conversion', {
      'send_to': 'G-FZYCZK58SP',
      'value': 1.00,
      'currency': 'USD'
    });
  };

}]);
